import { render, staticRenderFns } from "./SubscribeView.vue?vue&type=template&id=154c4866&scoped=true&"
import script from "./SubscribeView.vue?vue&type=script&lang=js&"
export * from "./SubscribeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c4866",
  null
  
)

export default component.exports